import { Link } from "@bca/ui-library";
import css from "@styled-system/css";
import styled from "styled-components";

import pushToDigitalData from "../../../analytics/pushToDigitalData";
import { MechanicalItemReportAnalytics } from "../../../analytics/MechanicalItemReportAnalytics";
import { ReportDetailsProps } from "../mechanical-report.types";
import { shallowEqual, useSelector } from "react-redux";
import { StoreType } from "../../../redux/StoreType";
import { GET_VENDOR_IMPERSONATION_STATE } from "../../../redux/slices/impersonationSlice";
import { GET_USER_STATE } from "../../../redux/slices/userSlice";

const StyledLink = styled(Link)`
  ${css({
    fontSize: "body-small",
    textAlign: "center",
    paddingRight: [10, 0],
  })}
`;

export const LinkElement: React.FunctionComponent<ReportDetailsProps> = ({
  reportType,
  anchorLink,
  categoryMapping,
  title,
}) => {
  const result = MechanicalItemReportAnalytics({ reportType, categoryMapping });

  const {
    user: { isVendorAdmin },
  }: StoreType = useSelector(GET_USER_STATE, shallowEqual);
  const {
    impersonation: { isVendorImpersonationSet },
  }: StoreType = useSelector(GET_VENDOR_IMPERSONATION_STATE, shallowEqual);

  const pushAnalytics = () => {
    if (
      (isVendorAdmin && isVendorImpersonationSet) ||
      isVendorAdmin === false
    ) {
      pushToDigitalData({
        event: {
          name: "click",
          category: "link",
          label: result,
          action: "download",
          section: "primary-information",
        },
      });
    }
  };

  return (
    <StyledLink
      href={anchorLink}
      target="_blank"
      color="primary-light-blue"
      underline="always"
      onClick={pushAnalytics}
    >
      {title}
    </StyledLink>
  );
};
